<template>
  <div class="common-modal">
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="modal-inner">
        <div class="custom-modal-header">
          <div class="close-btn">
            <div
              class="btn-close"
              @click="$emit('close')"
              v-if="closeIconVisible"
            ></div>
          </div>
        </div>
        <slot :name="header"></slot>
        <div class="button-container">
          <button
            :class="{ 'loading-btn': btn.loading }"
            v-for="(btn, index) in buttons"
            :key="index"
            class="buttons"
            @click="onClick(index)"
            :disabled="buttons.some((el) => el.loading)"
          >
            <div>{{ btn.text }}</div>
            <b-spinner
              label="Spinning"
              small
              style="width: 20px; height: 20px; color: #6a6a74"
              v-if="btn.loading"
            ></b-spinner>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonModal',
  props: {
    buttons: { required: true, type: Array, default: [] },
    closeIconVisible: { required: false, type: Boolean, default: false },
    header: { required: true, type: String, default: '' },
  },
  methods: {
    async onClick(index) {
      this.$emit(this.buttons[index].action, index);
    },
  },
};
</script>
<style scoped>
.common-modal .modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1055;
}

.common-modal .modal {
  padding: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 10px;
  display: block;
}

.common-modal .modal .modal-inner {
  width: fit-content;
  height: fit-content;
  background: #fff;
  padding: 30px 40px 20px 40px;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.common-modal .custom-modal-header {
  box-sizing: border-box;
  display: block;
  position: relative;
}
.common-modal .modal .btn-close:focus {
  outline: none;
  box-shadow: none;
}

.common-modal .modal .btn-close {
  position: absolute;
  right: -25px;
  top: -14px;
  padding: 0;
}

.common-modal .modal-inner .buttons {
  background: white;
  padding: 3px 20px;
  border: 1px solid #cdcdcd;
  color: #9090a2;
  border-radius: 7px;
  font-size: 18px;
  line-height: 30px;
}

.common-modal .modal-inner .button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.common-modal .loading-btn {
  position: relative;
}

.common-modal .loading-btn div {
  visibility: hidden;
}

.common-modal .loading-btn span {
  position: absolute;
  top: 7px;
  left: calc(50% - 10px);
}
</style>
